'use client';
import Image from 'next/image';
import Link from 'next/link';

export default function Footer() {
  return (
    <footer data-component-id="src/app/Footer.tsx:7:4" data-component-path="src/app/Footer.tsx" data-component-line="7" data-component-end-line="101" data-component-file="Footer.tsx" data-component-name="footer" data-component-content="%7B%22elementName%22%3A%22footer%22%2C%22className%22%3A%22%5Cn%20%20%20%20%20%20%20%20w-full%5Cn%20%20%20%20%20%20%20%20bg-no-repeat%5Cn%20%20%20%20%20%20%20%20bg-cover%5Cn%20%20%20%20%20%20%20%20bg-center%5Cn%20%20%20%20%20%20%22%7D"
      className="
        w-full
        bg-no-repeat
        bg-cover
        bg-center
      "
      style={{
        backgroundImage: "url('/images/memecon-footer.svg')",
      }}
    >
      <div data-component-id="src/app/Footer.tsx:18:6" data-component-path="src/app/Footer.tsx" data-component-line="18" data-component-end-line="100" data-component-file="Footer.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22%5Cn%20%20%20%20%20%20%20%20%20%20w-full%5Cn%20%20%20%20%20%20%20%20%20%20min-h-%5B140px%5D%20sm%3Amin-h-%5B160px%5D%20md%3Amin-h-%5B180px%5D%5Cn%20%20%20%20%20%20%20%20%20%20flex%20justify-between%20items-center%5Cn%20%20%20%20%20%20%20%20%20%20px-%5B20px%5D%20sm%3Apx-%5B30px%5D%20md%3Apx-%5B50px%5D%20lg%3Apx-%5B70px%5D%5Cn%20%20%20%20%20%20%20%20%20%20py-%5B24px%5D%20sm%3Apy-%5B28px%5D%20md%3Apy-%5B32px%5D%5Cn%20%20%20%20%20%20%20%20%22%7D"
        className="
          w-full
          min-h-[140px] sm:min-h-[160px] md:min-h-[180px]
          flex justify-between items-center
          px-[20px] sm:px-[30px] md:px-[50px] lg:px-[70px]
          py-[24px] sm:py-[28px] md:py-[32px]
        "
      >
        
        {/* Logo */}
        <Link data-component-id="src/app/Footer.tsx:29:8" data-component-path="src/app/Footer.tsx" data-component-line="29" data-component-end-line="38" data-component-file="Footer.tsx" data-component-name="Link" data-component-content="%7B%22elementName%22%3A%22Link%22%2C%22href%22%3A%22%2F%22%2C%22className%22%3A%22flex%20items-center%22%7D" href="/" className="flex items-center">
          <Image data-component-id="src/app/Footer.tsx:30:10" data-component-path="src/app/Footer.tsx" data-component-line="30" data-component-end-line="37" data-component-file="Footer.tsx" data-component-name="Image" data-component-content="%7B%22elementName%22%3A%22Image%22%2C%22src%22%3A%22%2Fimages%2Flogo-footer.svg%22%2C%22alt%22%3A%22logo%22%2C%22className%22%3A%22h-auto%20w-%5B115px%5D%20sm%3Aw-%5B125px%5D%20lg%3Aw-%5B140px%5D%22%7D"
            src="/images/logo-footer.svg"
            alt="logo"
            width={140}
            height={40}
            priority
            className="h-auto w-[115px] sm:w-[125px] lg:w-[140px]"
          />
        </Link>

        {/* Social Icons */}
        <div data-component-id="src/app/Footer.tsx:41:8" data-component-path="src/app/Footer.tsx" data-component-line="41" data-component-end-line="99" data-component-file="Footer.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20items-center%20gap-%5B18px%5D%20sm%3Agap-%5B24px%5D%20md%3Agap-%5B30px%5D%22%7D" className="flex items-center gap-[18px] sm:gap-[24px] md:gap-[30px]">
          
          <Link data-component-id="src/app/Footer.tsx:43:10" data-component-path="src/app/Footer.tsx" data-component-line="43" data-component-end-line="56" data-component-file="Footer.tsx" data-component-name="Link" data-component-content="%7B%22elementName%22%3A%22Link%22%2C%22href%22%3A%22https%3A%2F%2Fx.com%2FMemeConEvents%22%7D"
            href="https://x.com/MemeConEvents"
            target="_blank"
            rel="noopener noreferrer nofollow"
          >
            <Image data-component-id="src/app/Footer.tsx:48:12" data-component-path="src/app/Footer.tsx" data-component-line="48" data-component-end-line="55" data-component-file="Footer.tsx" data-component-name="Image" data-component-content="%7B%22elementName%22%3A%22Image%22%2C%22src%22%3A%22%2Fimages%2Ffooter-twitter.svg%22%2C%22alt%22%3A%22X-Twitter%22%2C%22className%22%3A%22w-%5B18px%5D%20md%3Aw-%5B22px%5D%20lg%3Aw-%5B24px%5D%20h-auto%20hover%3Aopacity-80%20transition-opacity%22%7D"
              src="/images/footer-twitter.svg"
              alt="X-Twitter"
              width={24}
              height={24}
              className="w-[18px] md:w-[22px] lg:w-[24px] h-auto hover:opacity-80 transition-opacity"
              unoptimized
            />
          </Link>

          <Link data-component-id="src/app/Footer.tsx:58:10" data-component-path="src/app/Footer.tsx" data-component-line="58" data-component-end-line="71" data-component-file="Footer.tsx" data-component-name="Link" data-component-content="%7B%22elementName%22%3A%22Link%22%2C%22href%22%3A%22https%3A%2F%2Fwww.instagram.com%2Fjoinmemecon%2F%22%7D"
            href="https://www.instagram.com/joinmemecon/"
            target="_blank"
            rel="noopener noreferrer nofollow"
          >
            <Image data-component-id="src/app/Footer.tsx:63:12" data-component-path="src/app/Footer.tsx" data-component-line="63" data-component-end-line="70" data-component-file="Footer.tsx" data-component-name="Image" data-component-content="%7B%22elementName%22%3A%22Image%22%2C%22src%22%3A%22%2Fimages%2Finstagram-logo.svg%22%2C%22alt%22%3A%22Instagram%22%2C%22className%22%3A%22w-%5B18px%5D%20md%3Aw-%5B22px%5D%20lg%3Aw-%5B24px%5D%20h-auto%20hover%3Aopacity-80%20transition-opacity%22%7D"
              src="/images/instagram-logo.svg"
              alt="Instagram"
              width={24}
              height={24}
              className="w-[18px] md:w-[22px] lg:w-[24px] h-auto hover:opacity-80 transition-opacity"
              unoptimized
            />
          </Link>

          <Link data-component-id="src/app/Footer.tsx:73:10" data-component-path="src/app/Footer.tsx" data-component-line="73" data-component-end-line="86" data-component-file="Footer.tsx" data-component-name="Link" data-component-content="%7B%22elementName%22%3A%22Link%22%2C%22href%22%3A%22http%3A%2F%2Ft.me%2Fmemeconorg%22%7D"
            href="http://t.me/memeconorg"
            target="_blank"
            rel="noopener noreferrer nofollow"
          >
            <Image data-component-id="src/app/Footer.tsx:78:12" data-component-path="src/app/Footer.tsx" data-component-line="78" data-component-end-line="85" data-component-file="Footer.tsx" data-component-name="Image" data-component-content="%7B%22elementName%22%3A%22Image%22%2C%22src%22%3A%22%2Fimages%2Ftelegram.svg%22%2C%22alt%22%3A%22telegram%22%2C%22className%22%3A%22w-%5B16px%5D%20md%3Aw-%5B18px%5D%20lg%3Aw-%5B20px%5D%20h-auto%20hover%3Aopacity-80%20transition-opacity%22%7D"
              src="/images/telegram.svg"
              alt="telegram"
              width={20}
              height={18}
              className="w-[16px] md:w-[18px] lg:w-[20px] h-auto hover:opacity-80 transition-opacity"
              unoptimized
            />
          </Link>

          <a data-component-id="src/app/Footer.tsx:88:10" data-component-path="src/app/Footer.tsx" data-component-line="88" data-component-end-line="97" data-component-file="Footer.tsx" data-component-name="a" data-component-content="%7B%22elementName%22%3A%22a%22%2C%22href%22%3A%22mailto%3Amedia%40meme-con.org%22%7D" href="mailto:media@meme-con.org">
            <Image data-component-id="src/app/Footer.tsx:89:12" data-component-path="src/app/Footer.tsx" data-component-line="89" data-component-end-line="96" data-component-file="Footer.tsx" data-component-name="Image" data-component-content="%7B%22elementName%22%3A%22Image%22%2C%22src%22%3A%22%2Fimages%2Fmail-icon.svg%22%2C%22alt%22%3A%22mail-icon%22%2C%22className%22%3A%22w-%5B20px%5D%20md%3Aw-%5B24px%5D%20lg%3Aw-%5B26px%5D%20h-auto%20hover%3Aopacity-80%20transition-opacity%22%7D"
              src="/images/mail-icon.svg"
              alt="mail-icon"
              width={26}
              height={18}
              className="w-[20px] md:w-[24px] lg:w-[26px] h-auto hover:opacity-80 transition-opacity"
              unoptimized
            />
          </a>

        </div>
      </div>
    </footer>
  );
}